// Kleine, testbare hulpjes voor het Control-scherm.
const GROEN = "#34bd82", GEEL = "#e0a82e", ROOD = "#e5564e", GRIJS = "#a0a4af";

export const TIER_TEKST = {
  0: "Lezen en loggen: automatisch",
  1: "Concept of intern werk: automatisch, gelogd",
  2: "Naar buiten of onomkeerbaar: jouw goedkeuring",
  3: "Geld, verwijderen of rechten: goedkeuring plus nieuwe bevestiging",
  4: "Verboden: altijd geblokkeerd",
};

// Kleur van het kostenpercentage: groen tot 80, geel tot 100, daarna rood. Zonder limiet: grijs.
export function kostenKleur(pct) {
  if (pct == null || !Number.isFinite(Number(pct))) return GRIJS;
  const p = Number(pct);
  return p >= 100 ? ROOD : p >= 80 ? GEEL : GROEN;
}

export const statusKleur = (s) => (s === "actief" ? GROEN : s === "gepauzeerd" ? GEEL : s === "stilgezet" ? ROOD : GRIJS);
export const statusTekst = (s) => (s === "actief" ? "aan" : s === "gepauzeerd" ? "gepauzeerd" : s === "stilgezet" ? "stilgezet" : "onbekend");

const MAANDEN = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
export const maandLabel = (iso) => {
  const m = Number(String(iso || "").slice(5, 7));
  return m >= 1 && m <= 12 ? MAANDEN[m - 1] : "";
};

// Groepeert omzetregels per module (nieuwste maand eerst) en geeft de omzet van de huidige maand terug.
export function omzetPerModule(regels, modules, nu = new Date()) {
  const huidig = nu.getFullYear() + "-" + String(nu.getMonth() + 1).padStart(2, "0");
  const naam = new Map((modules || []).map((m) => [m.slug, m.naam]));
  const per = new Map();
  for (const r of regels || []) {
    if (!per.has(r.module)) per.set(r.module, []);
    per.get(r.module).push({ maand: r.maand, bedrag_eur: Number(r.bedrag_eur) || 0 });
  }
  return [...per.entries()].map(([slug, maanden]) => {
    maanden.sort((a, b) => (a.maand < b.maand ? 1 : -1));
    const dez = maanden.find((x) => String(x.maand).slice(0, 7) === huidig);
    return { slug, naam: naam.get(slug) || slug, maanden, dezeMaand: dez ? dez.bedrag_eur : 0 };
  }).sort((a, b) => b.dezeMaand - a.dezeMaand);
}
